import { Injectable } from "@angular/core";
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
} from "@angular/common/http";
import { Observable } from "rxjs";

export interface RequestAuditEntry {
  url: string;
  method: string;
  timestamp: number;
  duplicateCount: number;
  duplicates: number[];
}

@Injectable({ providedIn: "root" })
export class RequestAuditInterceptor implements HttpInterceptor {
  private static requestLog: RequestAuditEntry[] = [];
  private static requestCounts = new Map<string, number[]>();
  private static sessionStart = Date.now();

  static getLog(): RequestAuditEntry[] {
    return [].slice.call(RequestAuditInterceptor.requestLog).sort(function(a: RequestAuditEntry, b: RequestAuditEntry) {
      return b.timestamp - a.timestamp;
    });
  }

  static getDuplicates(minCount: number): RequestAuditEntry[] {
    return RequestAuditInterceptor.requestLog.filter(function(r: RequestAuditEntry) {
      return r.duplicateCount >= minCount;
    });
  }

  static getReport(): string {
    var duplicates = RequestAuditInterceptor.getDuplicates(2);
    if (duplicates.length === 0) {
      return "Nenhuma requisicao duplicada detectada.";
    }

    var report = "=== RELATORIO DE REQUISICOES DUPLICADAS ===\n";
    report += "Session Start: " + new Date(RequestAuditInterceptor.sessionStart).toLocaleString() + "\n";
    report += "Total Requests: " + RequestAuditInterceptor.requestLog.length + "\n";
    report += "Duplicates (2+): " + duplicates.length + "\n\n";

    duplicates.forEach(function(entry: RequestAuditEntry, idx: number) {
      report += (idx + 1) + ". [" + entry.method + "] " + entry.url + "\n";
      report += "   Chamadas: " + entry.duplicateCount + "x | Timestamps: " + entry.duplicates.join(", ") + "\n\n";
    });

    return report;
  }

  static exportCSV(): string {
    var duplicates = RequestAuditInterceptor.getDuplicates(1);
    var csv = "url,method,duplicateCount,timestamps\n";
    duplicates.forEach(function(entry: RequestAuditEntry) {
      csv += '"' + entry.url + '","' + entry.method + '",' + entry.duplicateCount + ',"' + entry.duplicates.join(";") + '"\n';
    });
    return csv;
  }

  static clear(): void {
    RequestAuditInterceptor.requestLog = [];
    RequestAuditInterceptor.requestCounts = new Map();
    RequestAuditInterceptor.sessionStart = Date.now();
  }

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    var url = req.url;
    var method = req.method;
    var timestamp = Date.now();

    var counts = RequestAuditInterceptor.requestCounts.get(url);
    if (!counts) {
      counts = [];
    }
    counts.push(timestamp);
    RequestAuditInterceptor.requestCounts.set(url, counts);

    var duplicateCount = counts.length;

    var entry: RequestAuditEntry = {
      url: url,
      method: method,
      timestamp: timestamp,
      duplicateCount: duplicateCount,
      duplicates: counts,
    };
    RequestAuditInterceptor.requestLog.push(entry);

    return next.handle(req);
  }
}

(window as unknown as Window & {
  requestAudit: {
    getLog: typeof RequestAuditInterceptor.getLog;
    getDuplicates: typeof RequestAuditInterceptor.getDuplicates;
    getReport: typeof RequestAuditInterceptor.getReport;
    exportCSV: typeof RequestAuditInterceptor.exportCSV;
    clear: typeof RequestAuditInterceptor.clear;
  };
}).requestAudit = {
  getLog: RequestAuditInterceptor.getLog,
  getDuplicates: RequestAuditInterceptor.getDuplicates,
  getReport: RequestAuditInterceptor.getReport,
  exportCSV: RequestAuditInterceptor.exportCSV,
  clear: RequestAuditInterceptor.clear,
};